import * as req from 'api/actions';
import * as c from './constant';

export const getCategoryList = (payload, callback) =>
  req.list(
    c.GET_CATEGORIES,
    'api/v1/administrators/social_amelioration_citizens/settings/solo_parent_categories',
    payload,
    callback
  );

export const showCategory = (id, payload, callback) =>
  req.item(
    c.SHOW_CATEGORY,
    `api/v1/administrators/social_amelioration_citizens/settings/solo_parent_categories/${id}`,
    payload,
    callback
  );

export const updateCategory = (id, payload, callback) =>
  req.update(
    c.UPDATE_CATEGORY,
    `api/v1/administrators/social_amelioration_citizens/settings/solo_parent_categories/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const clearCategory = () => req.setList(c.GET_CATEGORIES, []);

export const createCategory = (payload, callback) =>
  req.create(
    c.CREATE_CATEGORY,
    `api/v1/administrators/social_amelioration_citizens/settings/solo_parent_categories`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeCategory = (id, payload, callback) =>
  req.remove(
    c.REMOVE_CATEGORY,
    `api/v1/administrators/social_amelioration_citizens/settings/solo_parent_categories/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Remove !');
      if (callback) callback();
    }
  );
